import { ethnicityTypes } from "../../../../../../../enum/ethnicityType";
import useTitanApp from "../../../../../../../hooks/useTitanApp";
import { genderTypes } from "../../../../../../../enum/genderTypes";
import { getAge } from "../../../../../../../utils/getAge";
import dayjs from "dayjs";

export default function PatientFormFields() {
  const { patientState } = useTitanApp();
  const { selectedPatient, selectedPatientDetails } = patientState || {};
  const surgeryName = selectedPatientDetails?.surgery?.name || "-";

  const doctorName =
    selectedPatientDetails?.surgery?.generalPractitioner?.name || "-";
  return (
    <div className="form-fields">
      <div className="grid">
        <div className="field">
          <p className="label">Name</p>
          <p className="value">
            {selectedPatient
              ?.split(" ")
              .filter((word) => word !== "null" && word !== "undefined")
              .join(" ") || "-"}
          </p>
        </div>
        <div className="field">
          <p className="label">Date of birth</p>
          <p className="value">
            {`${dayjs(selectedPatientDetails?.dob).format(
              "DD/MM/YYYY"
            )} (${getAge(selectedPatientDetails?.dob)})` || "-"}
          </p>
        </div>
        <div className="field">
          <p className="label">Gender</p>
          <p className="value">
            {genderTypes[selectedPatientDetails?.sex] || "-"}
          </p>
        </div>
        <div className="field">
          <p className="label">NHS No.</p>
          <p className="value">{selectedPatientDetails?.nhsNumber || "-"}</p>
        </div>
        <div className="field">
          <p className="label">Telephone</p>
          <p className="value">
            {selectedPatientDetails?.contacts === null
              ? "-"
              : selectedPatientDetails?.contacts?.[0]?.value || "-"}
          </p>
        </div>
        <div className="field">
          <p className="label">Ethnicity</p>
          <p className="value">
            {ethnicityTypes[selectedPatientDetails?.ethnicity] || "-"}
          </p>
        </div>
      </div>

      <div className="single">
        <div className="field">
          <p className="label">Email</p>
          <p className="value">{selectedPatientDetails?.email || "-"}</p>
        </div>
        <div className="field">
          <p className="label">Address</p>
          <p className="value">{selectedPatientDetails?.address || "-"}</p>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="field">
            <p className="label">Surgery</p>
            <p className="value">{surgeryName}</p>
          </div>
          <div className="field">
            <p className="label">Doctor</p>
            <p className="value">{doctorName}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
